import { MARK_NO_SHOW, MARK_NO_SHOW_SUCCESS, MARK_NO_SHOW_ERROR, MARK_NO_SHOW_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const MarkNoShow = (state = initialState, action) => {
  switch (action.type) {
    case MARK_NO_SHOW:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case MARK_NO_SHOW_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case MARK_NO_SHOW_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case MARK_NO_SHOW_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default MarkNoShow;
